import { NavLink, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Handshake, Store } from "lucide-react";

const TABS = [
  { to: "/rete-gestione/accordi", label: "Accordi di Maggior Favore", tid: "rete-tab-accordi" },
  { to: "/rete-gestione/convenzioni", label: "Convenzioni", tid: "rete-tab-convenzioni" },
];

// Rete Solidale per i Partner abilitati dall'Admin: stesse pagine e poteri dell'Agenzia.
export default function ReteGestione() {
  const { user } = useAuth();
  if (!user?.rete_solidale_access) return <Navigate to="/" replace />;
  return (
    <div className="space-y-5" data-testid="rete-gestione">
      <div className="flex flex-wrap items-center gap-3">
        <Handshake className="h-6 w-6 text-terracotta" />
        <h1 className="font-heading text-2xl font-bold text-forest">Rete Solidale</h1>
        <span className="rounded-full bg-sage px-2.5 py-0.5 text-xs text-forest">Accesso concesso dall'Agenzia</span>
      </div>
      <div className="flex flex-wrap gap-2 border-b pb-2">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} data-testid={t.tid}
            className={({ isActive }) => `rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${isActive ? "bg-forest text-white" : "text-forest hover:bg-sage"}`}>{t.label}</NavLink>
        ))}
        <a href="/cooperative-convenzionate" target="_blank" rel="noreferrer" data-testid="rete-tab-vetrina" className="flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium text-forest hover:bg-sage"><Store className="h-4 w-4" />Vetrina cooperative</a>
      </div>
      <Outlet />
    </div>
  );
}
